import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { batchEventsConfig } from '@v2/pages/productionOrder/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const ProductionOrderDetailsBatchEventsStack = createStackNavigator();

const ProductionOrderDetailsBatchEventsNavigator = (props: any) => {
  return (
    <ProductionOrderDetailsBatchEventsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {batchEventsConfig.map(({ Component, name }) => (
        <ProductionOrderDetailsBatchEventsStack.Screen key={name} name={name} component={Component} initialParams={props.route?.params} />
      ))}
    </ProductionOrderDetailsBatchEventsStack.Navigator>
  );
};

export { ProductionOrderDetailsBatchEventsNavigator };
